import { styled } from '@mui/material';

export const Inventive = styled('iframe')`
  position: relative;
  height: 100%;
  width: 100%;
  padding-lfet: 88px;
  border: none;
  border-radius: 10px;
  background: rgba(255, 255, 255, 0.7);
`;

export const ChatWrapper = styled('div')`
  position: 'fixed';
`;
